import React from "react";
import './kukenan_trek.css';
import fotoa from '../images/explore/kukenan/RLC_8269a.JPG'
import fotob from '../images/explore/kukenan/RLC_8418a.JPG'
import fotoc from '../images/explore/kukenan/RLC_8486a.JPG'
import fotod from '../images/explore/kukenan/RLC_8430a.JPG'

const AngelFallsAbseil = () => {
  return(
    <div className="">

        <div className="">
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    
                    <div className="carousel-item active">
                    <img className="d-block w-100" src={fotoa} alt=""/> 
                    </div>
                    
                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotob} alt=""/>
                    </div>
                    
                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotoc} alt=""/>
                    </div>
                    
                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotod} alt=""/>
                    </div>
                    
                </div>
                <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        </div>
        
        <div className="card text-center">
            <div className="card-header bg-white">
                <h3>Kukenán Tepuy Trek</h3>
            </div>
            
            <div className="card-header bg-white">
                <h5>Next dates: <b>On demand</b></h5>
            </div>
            
            <a href="/request_info" className="rounded-0 btn btn-lg btn-primary btn-block">Interested?</a>
            
            <div className="card-header">
            
                <nav>
                    <div className="nav nav-tabs justify-content-center" id="nav-tab" role="tablist">
                        <a className="nav-item nav-link active" id="nav-trip-tab" data-toggle="tab" href="#nav-trip" role="tab" aria-controls="nav-trip" aria-selected="true">The Trip</a>
                        <a className="nav-item nav-link" id="nav-info-tab" data-toggle="tab" href="#nav-info" role="tab" aria-controls="nav-info" aria-selected="false">General Info</a>
                        <a className="nav-item nav-link" id="nav-itinerary-tab" data-toggle="tab" href="#nav-itinerary" role="tab" aria-controls="nav-itinerary" aria-selected="false">Itinerary</a>
                        <a className="nav-item nav-link" id="nav-included-tab" data-toggle="tab" href="#nav-included" role="tab" aria-controls="nav-included" aria-selected="false">What's Included</a>
                        <a className="nav-item nav-link" id="nav-faq-tab" data-toggle="tab" href="#nav-faq" role="tab" aria-controls="nav-faq" aria-selected="false">FAQs</a>
                    </div>
                </nav>
                
                <div className="card-body">
                <div className="tab-content" id="nav-tabContent">

                    <div className="tab-pane fade show active container" id="nav-trip" role="tabpanel" aria-labelledby="nav-trip-tab">
                        
                        <div className="row text-justify">

                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold h4">The impossible  landscape</p>
                                <p>Gendarmes with alien shapes sculpted by water and wind, tiny black frogs that have lost the ability to jump, a diversity of carnivorous plants that have learned to survive in the poorest soils. Kukenán Tepuy is a journey through geological ages and, using the words of the renowned Venezuelan biologist Carlos Bosque, a journey to "a laboratory of evolution." The Taurepan, a local ethnic group, know this mountain by another name, Matawi, which could be translated as the place to die. In fact, the fear instilled by the cliffs that must be overcome to reach the top of this tepuy powerfully evokes this meaning and makes this trekking a true adventure.</p>
                                <p>In the words of Stephen Gibbs in an article for The Times: “The climb itself was three strenuous days of ascent, much of it through thick forest but worth every step. At the top, we spend two days exploring our alien surroundings, bathing in crystal-clear streams fringed by pink quartz sand. There were carnivorous plants, miniature frogs and primitive ferns that appeared like prototypes for the more advanced versions on Plant Earth below.”</p>
                            </div>
                            
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold h4">What to expect:</p>
                                
                                <p>-Fascinating geological formations.</p>
                                <p>-An exposed path that represents a challenge even for the most experienced hiker.</p>
                                <p>-Walk through rock labyrinths adorned with the strange vegetation of the tepuis.</p>
                                <p>-Unbeatable view of the neighboring Mount Roraima and the fascinating cloud factory that separates them.</p>
                                <p>-High quality mountain food. Specially designed to satisfy the nutritional needs of demanding daily Treks.</p>
                                <p>-Despite being next to the famous and crowded Mount Roraima, Kukenan Tepuy has been visited by very few people.</p>
                                <p>-Temperatures from 5 to 35 ºC depending on the altitude that ranges from 1200 to 2680 m.a.s.l. Wet equatorial climate, with plentiful precipitation, heavy cloud cover and high humidity.</p>
                            </div>
                        </div>
                    </div>
                
                    <div className="tab-pane fade container" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab">
                        <div className="row text-justify">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold">Location</p>
                                <p>Matawi is part of the eastern chain of tepuis, on the border with Brazil and Guyana, within the Canaima National Park (UNESCO World Heritage Site). At its highest point it reaches 2680 m.a.s.l. and the flat top of this mountain covers about 22 square kilometers.</p>
                                
                                <p className="font-weight-bold">The Trek</p>
                                <p>A three-day trek separates the summit of the Matawi Tepuy from the indigenous community of “Paraitepuy de Roraima”, the starting point of the excursion. The first day is a gentle walk of about 4 hours to the Tök River. On the second day the physical demand increases, since we will ascend the Tepuy foothills to the Base Camp, very close to Kukenan Falls. The third day, the hardest of the excursion, will be physically and psychologically challenging. After a laborious climb up the steep hillside of the eastern face of the mountain, we will have to climb a rock tower that leans against the summit. Towards the end of the day, some climbing gear will be used to secure the most exposed steps. This day we will reach a camp known as “El Hotel de Kukenan”, from which some summit excursions will depart.</p>
                            </div>
                            
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold">Highlights</p>
                                <p><u>Rock Mazes</u>. One of the aims of the excursion is to visit the strange and enigmatic sandstone formations, which spark the imagination, illustrating the centuries-old sculptural work of wind and water.</p>
                                <p><u>Kukenan Falls</u>. The water from one of the basins that form on the southeast end of the Tepuy flow into a spectacular waterfall of 674 uninterrupted meters. This gives it the third place in the list of highest waterfalls in Venezuela.</p>
                                <p><u>Northern Chasm</u>. The collapse of a cave system at the northern end of the mountain resulted in the formation of a chasm approximately 200m deep. This is one of the least visited sections of Kukenán Tepuy, few people have ventured to visit the depths of this imposing chasm, prior agreement it is possible to plan the descent and exploration of this geographical accident.</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="tab-pane fade container" id="nav-itinerary" role="tabpanel" aria-labelledby="nav-itinerary-tab">
                        <div className="row text-left">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold">Day 1: Caracas - Puerto Ordaz - Paraitepuy</p>
                                <p>Early flight (commercial) from Caracas to Puerto Ordaz. Once there, we’ll get onboard 4x4 vehicles to “Paraitepuy de Roraima”, it will be a long road trip of about 8 to 10 hours. Overnight in Paraitepuy’s basic cabins for an early departure next morning.</p>
                                <br/>

                                <p className="font-weight-bold">Day 2: Paraitepuy - Tokwono</p>
                                <p>Our trekking starts in Paraitepuy Village at 1.200 MASL. Today we will walk thru open savannah for  about 6 hours. Campsite will be set just beside the congruence of Kukenan and Tök rivers, a very nice place for a long river bath.</p>
                                <br/>

                                <p className="font-weight-bold">Day 3: Tokwono - Campamento Base</p>
                                <p>Up to Kukenan’s base camp. The path turns steeper and vegetation changes as we walk up over nice green slopes for 5 to 6 hours. Tonight we’ll sleep with Kukenan Tepuy as our guardian, temperature starts descending.</p>
                                <br/>
                                
                                <p className="font-weight-bold">Day 4: Campamento Base - Cima</p>
                                <p>A 6 hour hike to reach the top of the Tepuy. Time to focus on the terrain as it gets even steeper and occasionally vertical with some fixed rope sections. Everything around us is pretty much rocks. Once at the top and after a well deserved celebration we’ll set what will be our campsite for the next three nights.</p>
                            </div>
                            
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold">Days 5 and 6: Summit excursions</p>
                                <p>A couple of days at the summit to relax, explore and admire some amazing spots.</p>
                                <br/>

                                <p className="font-weight-bold">Day 7: Cima - Tokwono</p>
                                <p>First day of descent. After being in sort of like another world for a few days it’s time to go back. It will take us two days to get back to the point where our trek started. Today we’ll go all the way down to Tokwono Camp.</p>
                                <br/>

                                <p className="font-weight-bold">Day 8: Tokwono - Paraitepuy</p>
                                <p>Second and final day of descent. End of the trekking. Overnight in Paraitepuy’s basic cabins for an early departure next morning.</p>
                                <br/>

                                <p className="font-weight-bold">Day 9: Paraitepuy - Puerto Ordaz</p>
                                <p>Early breakfast to hit the road. A good moment for a last glimpse at the Tepuis aligned in the distance for we never know when/if we’re coming back. Overnight in a comfy Hotel.</p>
                                <br/>

                                <p className="font-weight-bold">Day 10: Puerto Ordaz - Caracas</p>
                                <p>Once we’ve had our breakfast, a shuttle will come pick us up to take us to “Manuel Carlos Piar” airport to board a commercial flight from Puerto Ordaz to Maiquetía airport – Caracas.</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="tab-pane fade container" id="nav-included" role="tabpanel" aria-labelledby="nav-included-tab">
                        <div className="row text-justify">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold h4">Included</p>
                                <p>- Flights Caracas - Puerto Ordaz / Puerto Ordaz – Caracas.</p>
                                <p>- Shuttle Puerto Ordaz - Paraitepuy / Paraitepuy - Puerto Ordaz.</p>
                                <p>- Shuttle Puerto Ordaz Hotel / Puerto Ordaz airport.</p>
                                <p>- Gourmet mountain food.</p>
                                <p>- Satellite phone (strictly for emergencies)</p>
                                <p>- Collective climbing gear for the fixed rope sections.</p>
                                <p>- High quality Camping tents.</p>
                                <p>- Expedition porters.</p>
                                <p>- Lodging (Puerto Ordaz, Paraitepuy - and Caracas Airport if booked)</p>
                                <p>- First Aid large kit.</p>
                                <p>- Experienced guides.</p>
                                <br/>
                            </div>

                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold h4">Not Included</p> 
                                <p>- Camping equipment (sleeping bag and insulating mattress).</p>
                                <p>- Unscheduled restaurant meals</p>
                                <p>- Unscheduled hotel nights</p>
                                <p>- Basic first aid kit.</p>
                                <p>- Sun screen and insect repellent.</p>
                                <p>- Personal porters.</p>
                                <p>- Insurance.</p>
                                <p>- International airfare.</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="tab-pane fade container" id="nav-faq" role="tabpanel" aria-labelledby="nav-faq-tab">
                        <div className="row text-justify">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <p className="font-weight-bold">How many people per team?</p>
                                <p>- Up to 12</p>
                                <br/>
                                <p className="font-weight-bold">Difficulty</p>
                                <p>- Medium-Hard</p>
                                <br/>
                                <p className="font-weight-bold">Best season</p>
                                <p>- From late October to April</p>
                                <br/>
                                <p className="font-weight-bold">Length of the expedition</p>
                                <p>- 10 days (Roundtrip, Caracas - Caracas)</p>
                                <br/>
                                <p className="font-weight-bold">Meeting point?</p>
                                <p>- The meeting point will be agreed according to the demands of the group. Foreign tourists will be received at the International Airport of Maiquetía "Simón Bolívar" or on the Brazil-Venezuela border.</p>
                                <br/>
                            </div>
                            
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <p className="font-weight-bold">How many people per tent?</p>
                                <p>- 2 people per tent unless otherwise specified.</p>
                                <br/>
                                <p className="font-weight-bold">Will there be a place to leave all the stuff not needed for the journey?</p>
                                <p>- Yes, luggage can be left in Paraitepuy. There may be a small charge, but typically it is free.</p>
                                <br/>
                                <p className="font-weight-bold">Is it possible to hire a personal porter?</p>
                                <p>- Yes, we can arrange to hire a personal porter for your pack. The cost of this service is not included in your land costs.</p>          
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <br/>
                                <a href="/request_info" className="rounded-0 btn btn-lg btn-primary btn-block">Request more info</a>
                                <br/>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            </div>

        </div>

    </div>
  );
};

export default AngelFallsAbseil;



// WEBPACK FOOTER //
// ./src/components/kukenan_trek.jsx